<template>
  <div v-if="stageContenttData?.pdData.showBlock" class="flex flex-wrap -mb-4" :style="guideStep >= 45 && guideStep <= 49 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div :ref="stageTreeList?.list?.Device.refName" class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['PositionAndDevice']['title']}}</span>
        <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Relationship']['title_info']}`"></i>
        <button
          v-if="!editPageType"
          id="relationship"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Relationship']['video_teaching']}}
        </button>
        <div v-show="stageIndex != 0 && _useStatus == true" class="float-right">
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="stageContenttData.pdData.ditto_identity" class="-my-1" :disabled="editPageType" />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8">
        <div>
          <div class="flex">
            <div class="text-grap-700 align-middle" :class="{ 'ring-4 border-blue-400': guideStep === 48 }">
              <InputSwitch :disabled="editPageType" v-model="stageContenttData.pdData.auto_publisher" @click="selectAll()" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['PositionAndDevice']['position_item_title']}}</span>
            </div>
          </div>
          <div class="flex">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_label']}}</span>
            </div>
          </div>
          <MultiSelect ref="step46Click" v-model="stageContenttData.pdData.device_platforms" :options="devicePlatformsList" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['device_placeholder']" :filter="false" class="w-full rounded-md multiselect-custom" :disabled="editPageType">
            <template #value="slotProps">
              <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                <div>{{selectDeviceLabel[option]}}</div>
              </div>
            </template>
          </MultiSelect>
        </div>
        <div>
          <div class="space-y-2 pt-4" :class="{ 'ring-4 border-blue-400': guideStep === 49 }">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_block_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'關係鏈與受眾'"></i> -->
            </div>
            <Dropdown
              :disabled="editPageType" v-model="stageContenttData.pdData.user_os" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.user_os_list" :placeholder="lang['components']['Event']['PositionAndDevice']['device_block_title_placeholder']" class="w-full rounded-md"
            />
          </div>
        </div>
      </div>
      <div class="flex-1 space-y-4" style="margin-top: 0px;">
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 46 }">
          <div class="flex pt-8">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['position_block_title']}}</span>
            </div>
          </div>
          <MultiSelect ref="step47Click" id="teachingPAD" v-model="stageContenttData.pdData.publisher_platforms" :options="stageContenttData.pdData.publisher_platforms_list" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']" :filter="false" class="w-full rounded-md multiselect-custom" :disabled="editPageType" :class="{ 'ring-4 border-blue-400': guideStep === 47 }">
            <template #value="slotProps">
                <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                  <div>{{platFormLabel[option]}}</div>
                </div>
                <template v-if="!slotProps.value || slotProps.value.length === 0">
                    {{lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']}}
                </template>
            </template>
          </MultiSelect>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-8" style="margin-top: 0px;" >
        <div style="position:relative">
          <loading :active="!showAdpagesLoading"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div class="flex justify-between mb-2">
            <div>
              <span class="text-grap-700 align-middle text-sm">Facebook</span>
              <button
                v-if="!editPageType"
                id="identity"
                class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
                @click="teachVideo()"
              >
                {{lang['components']['Event']['Identity']['video_teaching']}}
              </button>
            </div>

            <button
              v-if="!editPageType"
              class="text-blue-600 focus:outline-none rounded-xl px-2 py-0.5 text-white transition duration-500 ease-in-out border border-blue-600 text-sm"
              @click="updateAdpages">
              <i class="pi pi-refresh text-sm"></i>
              更新
            </button>
          </div>
          <input type="hidden" name="step_3_facebook" v-model="stageContenttData.pdData.page_id">
          <Dropdown :disabled="editPageType" v-model="stageContenttData.pdData.page_id" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.adpages_list" :placeholder="lang['components']['Event']['Identity']['facebook_placeholder']" class="w-full rounded-md" />
        </div>
        <div>
          <div class="mb-2.5">
            <span class="text-grap-700 align-middle text-sm">IG</span>
          </div>
          <Dropdown :disabled="true" v-model="stageContenttData.pdData.ig_username" optionLabel="name" optionValue="code" :options="stageContenttData.pdData.ig_list" placeholder="" class="w-full rounded-md" />
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import InputSwitch from 'primevue/inputswitch';
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'PositionAndDevice',
    components: {
      MultiSelect,
      Dropdown,
      InputSwitch,
      Loading
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      stageContent:{
        type: Object
      },
      stageContentAll:{
        type: Object
      },
      stageIndex: {
        type: Number
      },
      stageItemIndex: {
        type: Number
      },
      stageTreeHaveTest: {
        type: Boolean
      },
      stageTreeList:{
        type: Object
      },
      showIdentity: {
        type: Boolean
      },
      viewIdentityDatalist: {
        type: Object
      },
      autoPublisher: {
        type: Boolean
      },
      publisherPlatforms: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        autoPublisherForm: false,
        testValue: ["mobile","desktop"],
        devicePlatformsList: [
          {
            name: "行動裝置",
            code: "mobile",
            disabled: false
          },
          {
            name: "桌上型電腦",
            code: "desktop",
            disabled: false
          }
        ],
        selectDeviceLabel: {mobile:"行動裝置", desktop:"桌上型電腦"},
        publisherPlatFormsDb: [],
        platFormLabel: {facebook:"Facebook", instagram:"Instagram", audience_network:"Audience Network", messenger:"Messenger"},
        usAuto: true,
        selectedTags: [3, 7],
        tags: [
          {
            code: 1,
            text: '排除粉絲專頁',
            checked: false
          },
          {
            code: 2,
            text: '排除購買15天',
            checked: false
          },
          {
            code: 3,
            text: '排除購買30天',
            checked: true
          },
          {
            code: 4,
            text: '排除購買60天',
            checked: false
          },
          {
            code: 5,
            text: '排除RT30天',
            checked: true
          },
          {
            code: 6,
            text: '排除RT60天',
            checked: false
          },
          {
            code: 7,
            text: '預設選項',
            checked: false
          },
        ],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        positionDeviceIdentityStatus: false,
        isPdDataUpdating: false,
        _useStatus: false,
        showAdpagesLoading: true,
      }
    },
    watch: {
      // 'viewDatalistData.publisher_platforms'(value){
      //   console.log('viewDatalistData.publisher_platforms');
      //   console.log(value);
      //   let platformsLength = value.length;
      //   console.log(platformsLength);
      //   console.log(this.viewDatalistData.publisher_platforms);
      //   this.publisherPlatFormsDb = value
      //   if(platformsLength == 4){
      //     this.autoPublisherForm = true;
      //     this.autoPublisherData = true;
      //   } else {
      //     this.autoPublisherForm = false;
      //     this.autoPublisherData = false;
      //   }
      // },
      // 'autoPublisherData'(value){
      //   console.log('autoPublisherData');
      //   console.log(value);
      //   console.log(typeof value);
      //   if(value){
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
      //     this.publisherPlatFormsDb = ["facebook","instagram","audience_network","messenger"];
      //   } else {
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = [];
      //     this.publisherPlatFormsDb = [];
      //   }
      // },
      'lang':function(v){
        this.devicePlatformsList = [
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_mobile'],
            code: "mobile",
            disabled: false
          },
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_desktop'],
            code: "desktop",
            disabled: false
          }
        ];
        this.selectDeviceLabel = {mobile:this.lang['components']['Event']['PositionAndDevice']['device_mobile'], desktop:this.lang['components']['Event']['PositionAndDevice']['device_desktop']};
      },
      'stageContenttData': function(v){
        console.log('CustomizeEvent PositionAndDevice stageContenttData');
        console.log(v);
        console.log(this.stageIndex);
        console.log(this.stageContentAllData);

        // let _beforeIndex = this.stageIndex - 1;
        // let _tmpThisMethod = '';
        // if(this.stageContentAllData.subCampaignsContent != null && this.stageContentAllData.subCampaignsContent != '' && typeof this.stageContentAllData.subCampaignsContent !== 'undefined'){
        //   _tmpThisMethod = this.stageContentAllData.subCampaignsContent[this.stageIndex].method;
        // }
        // let _tmpBeforeMethod = '';
        // let metaList = ['META_TEST','META_KW','META_LA','META_RT','META_ASC'];
        // let tiktokList = ['TIKTOK_KW','TIKTOK_RT'];

        // console.log('_beforeIndex');
        // console.log(_beforeIndex);
        // if(_beforeIndex >= 0){
        //   _tmpBeforeMethod = this.stageContentAllData.subCampaignsContent[_beforeIndex].method;
        // }

        // console.log(_tmpThisMethod+' vs '+_tmpBeforeMethod);

        let _thisIsMeta = false;
        let _beforeIsMeta = false;
        let _thisIsTiktok = false;
        let _beforeIsTiktok = false;
        let _allIsMeta = false;
        let _allIsTiktok = false;

        // if (metaList.includes(_tmpThisMethod)) {
        //   _thisIsMeta = true
        // }

        // if (metaList.includes(_tmpBeforeMethod)) {
        //   _beforeIsMeta = true
        // }

        // if (tiktokList.includes(_tmpThisMethod)) {
        //   _thisIsTiktok = true
        // }

        // if (tiktokList.includes(_tmpBeforeMethod)) {
        //   _beforeIsTiktok = true
        // }

        // if(_thisIsMeta == true && _beforeIsMeta == true){
        //   _allIsMeta = true;
        // }

        // if(_thisIsTiktok == true && _beforeIsTiktok == true){
        //   _allIsTiktok = true;
        // }

        // if(_allIsMeta == true || _allIsTiktok == true){
          this._useStatus = true;
        // } else {
        //   this._useStatus = false;
        // }

        console.log('_thisIsMeta');
        console.log(_thisIsMeta);
        console.log('_beforeIsMeta');
        console.log(_beforeIsMeta);
        console.log('_thisIsTiktok');
        console.log(_thisIsTiktok);
        console.log('_beforeIsTiktok');
        console.log(_beforeIsTiktok);
        console.log('_allIsMeta');
        console.log(_allIsMeta);
        console.log('_allIsTiktok');
        console.log(_allIsTiktok);
        console.log('this._useStatus');
        console.log(this._useStatus);
      },
      'stageContenttData.pdData.device_platforms':function(v){
        console.log('stageContenttData.pdData.device_platforms');
        console.log(v);

        if(v != '' && v != null && typeof v !== 'undefined'){
          let devicePlatformsLength = v.length;

          if(v[0] == "desktop" && devicePlatformsLength == 1){
            this.stageContenttData.pdData.publisher_platforms_list = [
              {name: "Facebook", code: "facebook", disabled: true},
              {name: "Instagram", code: "instagram", disabled: true},
              {name: "Audience Network", code: "audience_network", disabled: true},
              {name: "Messenger", code: "messenger", disabled: true},
            ];
            this.publisherPlatFormsDb = ["facebook"];
          } else {
            this.stageContenttData.pdData.publisher_platforms_list = [
              {name: "Facebook", code: "facebook", disabled: false},
              {name: "Instagram", code: "instagram", disabled: false},
              {name: "Audience Network", code: "audience_network", disabled: false},
              {name: "Messenger", code: "messenger", disabled: false},
            ];
          }

          if(devicePlatformsLength == 2){
            this.autoPublisherForm = true
          } else {
            this.autoPublisherForm = false
          }
        }
      },
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'pad'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      guideStep(val) {
        // this.$refs.step47Click.show();
        // this.$refs.step47Click.overlayVisible = value === 47 ? true : false;
        if (val == 47) {
          // console.log(value);
          // this.$refs.step47Click.overlayVisible = true;
          // console.log(this.$refs.step47Click);
          // console.log(this.$refs.step47Click.overlayVisible);

          // this.$refs.step47Click.show();
          // document.getElementById("test").click();

          setTimeout(function(){
              // console.log("I am the third log after 1 seconds");
              document.getElementById("teachingPAD").click();
          },350);
        }

        if (val === 49) {
          this.stageContenttData.pdData.page_id = this.stageContenttData.pdData.adpages_list[0].code;
        }
      },
      'publisherPlatformsData'(value){
        console.log('publisherPlatformsData');
        console.log(value);

        this.publisherPlatFormsDb = value;

        console.log('this.publisherPlatFormsDb');
        console.log(this.publisherPlatFormsDb);
      },
      // 'autoPublisherForm'(value){
      //   console.log('autoPublisherForm');
      //   console.log(value);

      //   this.viewDatalistData.auto_publisher = value;
      // },
      'publisherPlatFormsDb'(value){
        console.log('publisherPlatFormsDb');
        console.log(value);
        // let platformsLength = value.length;

        // console.log('platformsLength');
        // console.log(platformsLength);

        if(typeof this.stageContenttData.pdData.publisher_platforms !== 'undefined'){
          this.stageContenttData.pdData.publisher_platforms = value;
        }
        // this.publisherPlatFormsDb = value;

        // if(platformsLength == 4){
        //   this.autoPublisherForm = true
        // } else {
        //   this.autoPublisherForm = false
        // }

        if(typeof this.stageContenttData.pdData.publisher_platforms === 'undefined'){
          this.stageContenttData.pdData.publisher_platforms = ['facebook', 'instagram', 'audience_network', 'messenger'];
        }

        console.log('this.stageContenttData.pdData.publisher_platforms');
        console.log(this.stageContenttData.pdData.publisher_platforms);
      },
      'stageContenttData.pdData.page_id': function(v){
        console.log('watch stageContenttData.pdData.page_id');
        console.log(v);

        this.$emit('childPageId', v);

        if(v != '' && v != null){
          this.showIdentityMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_page_instagram.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: v,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                console.log('response:'+response.data.return_data);
                // console.log('b this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
                this.stageContenttData.pdData.ig_username = response.data.return_data;
                this.stageContenttData.pdData.ig_id = response.data.ig_id;
                this.stageContenttData.pdData.ig_list = response.data.data_list;
                // console.log('a this.stageContenttData.pdData.ig_username:'+this.stageContenttData.pdData.ig_username);
              }

              this.showIdentityMyside = true;
            });
        }
      },
      'stageContenttData.pdData.ditto_identity'(value){
        console.log('stageContenttData.pdData.ditto_identity');
        console.log(value);
        console.log('b this.stageContentAllData');
        console.log(this.stageContentAllData);
        console.log(this.stageContenttData);
        console.log(this.stageIndex);

        if(this.stageIndex > 0){
          if(value == true){
            let _beforIndex = this.stageIndex - parseInt(1);
            let _beforeItemIndex = 0;

            console.log('b _beforeItemIndex', _beforeItemIndex);
            for(let i = 0; i < this.stageContentAllData[_beforIndex].length; i++){
              console.log('this.stageContentAllData['+_beforIndex+']['+i+']');
              if(this.stageContentAllData[_beforIndex][i].forwardData.showBlock === true){
                _beforeItemIndex = i;
              }
            }
            console.log('a _beforIndex', _beforIndex);
            console.log('a _beforeItemIndex', _beforeItemIndex);

            // this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData));

            // this.stageContentAllData[this.stageIndex].pdData.ditto_identity = value;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.auto_publisher = this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.auto_publisher;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.publisher_platforms));
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms_list = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.publisher_platforms_list));
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.device_platforms));
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.user_os = this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.user_os;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.user_os_list = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.user_os_list));
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.page_id = this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.page_id;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_id = this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.ig_id;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_username = this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.ig_username;
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.adpages_list = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.adpages_list));
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_list = JSON.parse(JSON.stringify(this.stageContentAllData[_beforIndex][_beforeItemIndex].pdData.ig_list));

            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ditto_identity = value;

            console.log('for this.stageContentAllData[this.stageIndex]');
            console.log(this.stageContentAllData[this.stageIndex]);

            if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
              let subLength =  this.stageContentAllData.length;
              console.log('this.stageIndex');
              console.log(this.stageIndex);
              for(let i = this.stageIndex; i < subLength; i++){
                let subItemLength =  this.stageContentAllData[i].length;
                for(let j = 0; j < subItemLength; j++){
                  if(this.stageContentAllData[i][j].pdData.ditto_identity == true){
                    this.stageContentAllData[i][j].pdData.auto_publisher = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.auto_publisher;
                    this.stageContentAllData[i][j].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms));
                    this.stageContentAllData[i][j].pdData.publisher_platforms_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms_list));
                    this.stageContentAllData[i][j].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.device_platforms));
                    this.stageContentAllData[i][j].pdData.user_os = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.user_os;
                    this.stageContentAllData[i][j].pdData.user_os_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.user_os_list));
                    this.stageContentAllData[i][j].pdData.page_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.page_id;
                    this.stageContentAllData[i][j].pdData.ig_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_id;
                    this.stageContentAllData[i][j].pdData.ig_username = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_username;
                    this.stageContentAllData[i][j].pdData.adpages_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.adpages_list));
                    this.stageContentAllData[i][j].pdData.ig_list = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_list));
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }

        console.log('a this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      'stageContenttData.pdData': {
        handler(newValue, oldValue) {
          console.log('pdData changed:', newValue);
          console.log('pdData olddata:', oldValue);

          if(this.isPdDataUpdating == true){
            return;
          }

          this.isPdDataUpdating = true;

          this.pdDataUdate(newValue);

          setTimeout(() => {
            this.isPdDataUpdating = false;
          }, 0);
        },
        deep: true // 深度监控
      },
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingMethod');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_pad')

        this.vars.start = 0
        this.vars.end = 16
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      testPAD() {
        console.log('hello')
        this.$refs.step47Click.show();
        this.$refs.step47Click.overlayVisible = true;
        console.log(this.$refs.step47Click);
      },
      selectAll (event) {
        // console.log(this.autoPublisherData)
        if(this.editPageType == false){
          if(!this.autoPublisherForm){
            this.autoPublisherForm = true;
            this.autoPublisherData = true;
            // this.stageContenttData.pdData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
            // this.publisherPlatFormsDb = ["facebook","instagram","audience_network","messenger"];
            this.stageContenttData.pdData.device_platforms = ["mobile","desktop"];
          } else {
            this.autoPublisherForm = false;
            this.autoPublisherData = false;
            this.stageContenttData.pdData.publisher_platforms = ["facebook"];
            this.publisherPlatFormsDb = ["facebook"];
            this.stageContenttData.pdData.device_platforms = ["desktop"];
          }
        }

        // if (!this.isSelect) {
        //   console.log('is checked');
        //   this.list.map(function(value, key) {
        //     console.log('value:'+value.name)
        //     if(value.status == 1){
        //       value.status = 2;
        //     }
        //   });
        // } else {
        //   console.log('un checked');
        // }
      },
      pdDataUdate(newValue){
        console.log(this.stageIndex);

        console.log('pdDataUdate stageContenttData.pdData');
        console.log(this.stageContentAllData);
        if(this.stageIndex > 0){
          let _beforeIndex = this.stageIndex - parseInt(1);
          let _beforeItemIndex = 0;

          console.log('b _beforeItemIndex', _beforeItemIndex);
          for(let i = 0; i < this.stageContentAllData[_beforeIndex].length; i++){
            console.log('this.stageContentAllData['+_beforeIndex+']['+i+']');
            if(this.stageContentAllData[_beforeIndex][i].forwardData.showBlock === true){
              _beforeItemIndex = i;
            }
          }
          console.log('a _beforeIndex', _beforeIndex);
          console.log('a _beforeItemIndex', _beforeItemIndex);

          console.log(this.stageContentAllData);
          console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex]);
          console.log(this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData);
          let _newDataAutoPublisher = newValue.auto_publisher;
          let _newDataPublisherPlatforms = JSON.stringify(newValue.publisher_platforms);
          let _newDataDevicePlatforms = JSON.stringify(newValue.device_platforms);
          let _newDataUserOs = newValue.user_os;
          let _newDataPageId = newValue.page_id;
          let _newDataIgId = newValue.ig_id;
          let _newDataIgUsername = newValue.ig_username;
          let _oldDataAutoPublisher = this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.auto_publisher;
          let _oldDataPublisherPlatforms = JSON.stringify(this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.publisher_platforms);
          let _oldDataDevicePlatforms = JSON.stringify(this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.device_platforms);
          let _oldDataUserOs = this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.user_os;
          let _oldDataPageId = this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.page_id;
          let _oldDataIgId = this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.ig_id;
          let _oldDataIgUsername = this.stageContentAllData[_beforeIndex][_beforeItemIndex].pdData.ig_username;

          // console.log(_newDataAutoPublisher);
          // console.log(_oldDataAutoPublisher);
          // console.log(_newDataLocales);
          // console.log(_oldDataLocales);
          // console.log(_newDataLocationRange);
          // console.log(_oldDataLocationRange);
          // console.log(_newDataLocations);
          // console.log(_oldDataLocations);
          // console.log(newValue.ditto_identity);

          if((_newDataAutoPublisher == _oldDataAutoPublisher) && (_newDataPublisherPlatforms == _oldDataPublisherPlatforms) && (_newDataDevicePlatforms == _oldDataDevicePlatforms) && (_newDataUserOs == _oldDataUserOs) && (_newDataPageId == _oldDataPageId) && (_newDataIgId == _oldDataIgId) && (_newDataIgUsername == _oldDataIgUsername) && newValue.ditto_identity == true){
            console.log('#一樣');
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ditto_identity = true;
          } else {
            console.log('#不一樣');
            this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ditto_identity = false;
          }
        } else {
          if(this.stageContentAllData != null && this.stageContentAllData != '' && typeof this.stageContentAllData !== 'undefined'){
            let subLength =  this.stageContentAllData.length;
            console.log('0');
            console.log(this.stageIndex);
            for(let i = 1; i < subLength; i++){
              let subItemLength =  this.stageContentAllData[i].length;
              for(let j = this.stageItemIndex; j < subItemLength; j++){
                // if(this.stageContentAllData[i][j].method != 'TIKTOK_KW' && this.stageContentAllData[i][j].method != 'TIKTOK_RT'){
                  if(this.stageContentAllData[i][j].pdData.ditto_identity == true || this.stageTreeHaveTest == true){
                    this.stageContentAllData[i][j].pdData.auto_publisher = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.auto_publisher;
                    console.log('this.stageContentAllData['+i+']['+j+'].pdData.publisher_platforms', this.stageContentAllData[i][j].pdData.publisher_platforms);
                    console.log('this.stageContentAllData['+this.stageIndex+']['+this.stageItemIndex+'].pdData.publisher_platforms', this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms);
                    this.stageContentAllData[i][j].pdData.publisher_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.publisher_platforms));
                    this.stageContentAllData[i][j].pdData.device_platforms = JSON.parse(JSON.stringify(this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.device_platforms));
                    this.stageContentAllData[i][j].pdData.user_os = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.user_os;
                    this.stageContentAllData[i][j].pdData.page_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.page_id;
                    this.stageContentAllData[i][j].pdData.location_types = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.location_types;
                    this.stageContentAllData[i][j].pdData.ig_id = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_id;
                    this.stageContentAllData[i][j].pdData.ig_username = this.stageContentAllData[this.stageIndex][this.stageItemIndex].pdData.ig_username;
                  } else {
                    break;
                  }
                // }
              }
            }
          }
        }

        console.log('pdDataUdate b this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      updateAdpages(){
        this.showAdpagesLoading = false;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_adpages.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            update_type: true
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.stageContenttData.pdData.adpages_list = response.data.return_data
            }

            this.showAdpagesLoading = true;
          });
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      stageContenttData:{
        get: function () {
          return this.stageContent
        },
        set: function (value) {
          this.$emit('update:stageContenttData', value)
        },
      },
      stageContentAllData:{
        get: function () {
          return this.stageContentAll
        },
        set: function (value) {
          this.$emit('update:stageContentAllData', value)
        },
      },
      viewIdentityDatalistData: {
        get: function () {
          return this.viewIdentityDatalist
        },
        set: function (value) {
          this.$emit('update:viewIdentityDatalistData', value)
        },
      },
      autoPublisherData: {
        get: function () {
          return this.autoPublisher
        },
        set: function (value) {
          this.$emit('update:autoPublisherData', value)
        },
      },
      publisherPlatformsData: {
        get: function () {
          return this.publisherPlatforms
        },
        set: function (value) {
          this.$emit('update:publisherPlatformsData', value)
        },
      },
    },
  }
</script>
<style lang="scss" scoped>
  /*::v-deep(.multiselect-custom) {
    .p-multiselect-token {
      font-size: .875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.25rem;
      display: inline-flex;
      margin: 0.25rem;
      --tw-bg-opacity: 1;
      background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  }*/

  ::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);

        img.flag {
            width: 17px;
        }
    }
  }
</style>